import { useState } from 'react';
import {
  pairingBoardFallback,
  pairingBoardSrc,
  type PairingBoardName,
} from './pairingBoards.js';

type PairingBoardImageProps = {
  name: PairingBoardName;
  className?: string;
};

/** Local board first; CDN fallback until operators drop files into public/pairing/boards. */
export function PairingBoardImage({ name, className }: PairingBoardImageProps) {
  const [src, setSrc] = useState(pairingBoardSrc(name));

  return (
    <img
      src={src}
      alt=""
      className={className}
      draggable={false}
      onError={() => {
        const fallback = pairingBoardFallback(name);
        if (src !== fallback) setSrc(fallback);
      }}
    />
  );
}
